import { render, staticRenderFns } from "./PartsManagement.vue?vue&type=template&id=4ff5de36&scoped=true"
import script from "./PartsManagement.vue?vue&type=script&lang=js"
export * from "./PartsManagement.vue?vue&type=script&lang=js"
import style0 from "./PartsManagement.vue?vue&type=style&index=0&id=4ff5de36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff5de36",
  null
  
)

export default component.exports